import jsonata from 'jsonata';
import { Condition } from '../model/rule-engine.model';
import { AbstractCondition } from './abstract-condition';

/**
 * Condition on assert uses jsonata expression given in params to evaluate a boolean condition
 */
export class JsonataCondition<T> extends AbstractCondition<T> implements Condition<T> {
  readonly type = 'jsonata';
  params: string;

  constructor(options: string | Pick<Condition<T>, 'params' | 'or'>) {
    super(typeof options === 'string' ? { params: options } : options);
  }

  /**
   * Uses jsonata expression to evaluate incoming facts (context) and produce a boolean result out of
   * given expression
   * @param context
   * @returns
   */
  assert(context: T): boolean {
    return !!jsonata(this.params).evaluate(context);
  }
}
